module.exports = __webpack_public_path__ + "img/sieckFinesseAdaptation11.7c50c15a.png";